<h2 mat-dialog-title>Delete {{ data.entryType }}</h2>
<mat-dialog-content>
    Are you sure you want to permanently delete this {{ data.entryType }} entry?
</mat-dialog-content>
<mat-dialog-actions>
    <button mat-raised-button color="primary" (click)="onCancel()">Cancel</button>
    <button mat-raised-button color="accent" (click)="onConfirm()">Delete</button>
</mat-dialog-actions>